import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import MissionVision from "@/components/site/MissionVision";
import Services from "@/components/site/Services";
import FounderFeature from "@/components/site/FounderFeature";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const Landing = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <MissionVision />
        <Services />
        <FounderFeature />
        <WhyChooseUs />
        <Contact />
      </main>
      <Footer />
      <Toaster
        richColors
        position="top-right"
        toastOptions={{
          style: { fontFamily: "Outfit, sans-serif" },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
